import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
var striptags = require('striptags');

function InfoMessage(props){
    // console.table(props);
    return(
        <div className="w-full mb-5 p-4 bg-garfield-bg-info grid grid-cols-6 gap-4 justify-items-center items-center">
                <FontAwesomeIcon icon={faInfoCircle} className="text-white self-center" size="2x" aria-hidden="true" />
                <ul className="w-full col-span-2">
                    {props.info.map((data, key) => {
                        let message = data.message? data.message: data
                        return(
                            <li className="w-full col-span-6" key={key}>{striptags(message)}</li>
                        )
                    })}
                </ul>    
        </div>
    )
}

export default InfoMessage;